import { cn } from '@/lib/utils';

interface LobbyTitleProps {
  title: string;
  isSettled: boolean;
}

const PLACEHOLDER = cn(
  'inline-block bg-gray-200 dark:bg-gray-800 rounded w-60 max-w-full h-[1em]',
  'align-middle animate-pulse',
);

const LobbyTitle = ({ title, isSettled }: LobbyTitleProps) => (
  <h1 aria-busy={!isSettled} className="text-gray-900 dark:text-gray-100 heading-3">
    {isSettled ? title : <span className={PLACEHOLDER} />}
  </h1>
);

export default LobbyTitle;
